@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper"  [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid" >
    <div class="col-12 text-right mb-4" >
      <div class=" notes-top-btn pt-2" >
        <button class="mr-2">All</button>
        <button>New </button>
      </div>
    </div>
    <div class="notes-field-section">
      <form>
        <div class="row">
          <div class="col-md-10">

            <div class="row">
              <div class="col-md-4" >
                <div class="form-group notes-field" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                  <input placeholder="Date" onfocus="(this.type='date')" id="date" name="date"
                    class="date-type form-control" ngModel #date="ngModel" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group notes-field" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                    <select id="month" name="month" class="date-type checks-dropdown form-control selectpicker" ngModel
                      #month="ngModel">
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group notes-field" [ngClass]="{ 'dark-input': selectedMode === 'dark' }">
                    <select id="year" name="year" class="checks-dropdown form-control date-type selectpicker" ngModel
                      #year="ngModel">
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-2">
              <div class="notes-filter-btn">
                <button class="form-control" type="submit">
                  Apply
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="notes-collapse-section mt-4">
        <div id="main">
          <div class="container-fluid px-0">
            <div class="accordion" id="faq">
              <notice-section [details]="noticeArr"></notice-section>
            </div>
          </div>
        </div>

      </div>

    </div>
  </main>